export default {
    base: {
        state: 'declaration.baseSetting.accountSubject',
        config: {
            url: '/accountSubject',
            abstract: true,
            template: '<div ui-view></div>',
            default: 'declaration.baseSetting.accountSubject.list',
            title: '会计科目',
        },
    },
    list: {
        state: 'declaration.baseSetting.accountSubject.list',
        config: {
            url: '/list',
            template: require('./view/accountSubject.html'),
            controller: 'accountSubjectCtrl',

        },
    },
}



// WEBPACK FOOTER //
// ./src/app/declaration/baseSetting/accountSubject/routers.js